import { ExportButton } from 'Components';
import { ExportButtonProps } from 'Components/ExportButton/ExportButton';
import { SystemRole } from 'Services/Api/Roles/Types';

export type RolesExportButtonProps = Omit<
	ExportButtonProps<Blob, never>,
	'query' | 'getQueryUrl' | 'onExport'
> & {
	dataSource: SystemRole[];
};

function RolesExportButton({
	dataSource,
	...props
}: RolesExportButtonProps) {
	const onExport = async () => {
		const headers = [
			'Role',
			'Description',
			'Type',
			'Users',
			'Last Update'
		];

		const rows = dataSource.map((role) => [
			role.roleName,
			role.description,
			role.type,
			role.usersCount,
			role.updatedDate
		]);

		const csv = [headers, ...rows]
			.map((row) =>
				row
					.map((value) =>
						`"${String(value ?? '').replace(/"/g, '""')}"`
					)
					.join(',')
			)
			.join('\n');

		const blob = new Blob([csv], {
			type: 'text/csv;charset=utf-8;'
		});

		const now = new Date();

		const date = now.toISOString().slice(0, 10);

		const time = now
			.toTimeString()
			.slice(0, 5)
			.replace(':', '_');

		const fileName = `system_roles_${date}_${time}.csv`;

		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');

		link.href = url;
		link.download = fileName;

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		URL.revokeObjectURL(url);

		return blob;
	};

	return (
		<ExportButton<Blob, never>
			{...props}
			className="roles-export-button"
			menu={false}
			onExport={onExport}
		/>
	);
}

export default RolesExportButton;